/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Input, Button, type TableColumnsType } from 'antd';

import { TMealPlanItem } from 'interfaces/mealPlan';

export const getTableColumns = ({ onInputChange, onRowDelete }): TableColumnsType<TMealPlanItem> => [
  {
    title: '메뉴명',
    dataIndex: 'mealPlanItemName',
    render: (value, record) => (
      <Input
        placeholder="예: 김치찌개"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'mealPlanItemName', target.value)}
      />
    )
  },
  {
    title: '알레르기 구성',
    dataIndex: 'description',
    render: (value, record) => (
      <Input defaultValue={value} onChange={({ target }) => onInputChange(record.sortBy, 'description', target.value)} />
    )
  },
  {
    title: '칼로리(Kcal)',
    dataIndex: 'calories',
    width: '100px',
    render: (value, record) => (
      <Input
        placeholder="예: 320"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'calories', target.value)}
      />
    )
  },
  {
    title: '탄수화물(g)',
    dataIndex: 'carbohydrate',
    width: '100px',
    render: (value, record) => (
      <Input
        placeholder="예: 320"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'carbohydrate', target.value)}
      />
    )
  },
  {
    title: '단백질(g)',
    dataIndex: 'protein',
    width: '100px',
    render: (value, record) => (
      <Input
        placeholder="예: 320"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'protein', target.value)}
      />
    )
  },
  {
    title: '지방(g)',
    dataIndex: 'fat',
    width: '100px',
    render: (value, record) => (
      <Input
        placeholder="예: 320"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'fat', target.value)}
      />
    )
  },
  {
    title: '나트륨(mg)',
    dataIndex: 'natrium',
    width: '100px',
    render: (value, record) => (
      <Input
        placeholder="예: 320"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'natrium', target.value)}
      />
    )
  },
  {
    title: '당류(g)',
    dataIndex: 'sugar',
    width: '100px',
    render: (value, record) => (
      <Input
        placeholder="예: 320"
        defaultValue={value}
        onChange={({ target }) => onInputChange(record.sortBy, 'sugar', target.value)}
      />
    )
  },
  {
    title: '삭제',
    dataIndex: 'sortBy',
    width: '100px',
    render: (value) => (
      <Button danger type="primary" onClick={() => onRowDelete(value)} style={{ borderRadius: '5px', fontSize: '15px' }}>
        삭제하기
      </Button>
    )
  }
];

const EXCEL_ROW_COUNT = 30;
const EXCEL_START_ROW = 3;

export const createCategoryData = (categories: { categoryId: string; categoryName: string }[]) => {
  return {
    categoryDatas: categories.map(({ categoryName, categoryId }) => [categoryName, categoryId]),
    categoryNames: categories.map(({ categoryName }) => [categoryName])
  };
};

export const createTargetExcelData = (): number[][] => {
  return Array(EXCEL_ROW_COUNT)
    .fill(0)
    .map((_, index) => [index + 1]);
};

export const createColumnValidations = (categoryNames: string[][]) => ({
  [EXCEL_START_ROW]: {
    minRowNumber: EXCEL_START_ROW.toString(),
    dataValidation: {
      type: 'list',
      formulae: [`"${categoryNames.join()}"`],
      allowBlank: true,
      showInputMessage: true,
      showErrorMessage: true,
      errorTitle: 'Error',
      error: '올바른 값을 선택해주세요'
    }
  }
});

export const createMealPlanFormulas = () => [
  {
    startAddress: 'D3',
    refAddress: 'C3',
    formula: (refAddress: string) => `IFERROR(VLOOKUP(${refAddress}, 'Temp'!A$2:B$100, 2, FALSE), "")`
  },
  {
    startAddress: 'I3',
    refAddress: 'G3',
    formula: (refAddress: string) => {
      const address = refAddress.split('')[1];
      return `IF(${refAddress}="사용",IF(COUNTIF('식단 구성'!$A$4:$A$303,'식단표 등록'!A${address})=0,"식단 구성 시트에서 1개 이상의 메뉴를 등록해주세요",COUNTIF('식단 구성'!$A$4:$A$303,'식단표 등록'!A${address})&"개의 식단 구성이 되어있습니다"),"")`;
    }
  }
];

export const createMealPlanItemFormulas = () => [
  {
    startAddress: 'J4',
    refAddress: 'A4',
    formula: (refAddress: string) => `IFERROR(VLOOKUP(${refAddress},'식단표 등록'!A:E,3),"")`
  },
  {
    startAddress: 'K4',
    refAddress: 'A4',
    formula: (refAddress: string) => `IFERROR(VLOOKUP(${refAddress},'식단표 등록'!A:E,5),"식단표 번호를 선택하세요")`
  }
];
